import React from "react";
import styled from "styled-components";
import { Button, Modal } from "antd";

import { ConfirmModalProps } from "../_types";
import ModalFooterLayout from "../ModalFooterLayout";

import useModals from "../../../../hooks/useModals";
import ModalTitle from "../styles/ModalTitle";

const ConfirmModal: React.FC<ConfirmModalProps> = function ConfirmModal({
  title,
  onCancel,
  isDanger,
  cancelText,
  onOk,

  contents,

  okText,
}) {
  const { closeModal, getLoading } = useModals();
  return (
    <StyledModal
      onOk={onOk || closeModal}
      onCancel={onCancel || closeModal}
      visible
      title={<ModalTitle>{title}</ModalTitle>}
      centered
      maskClosable={false}
      footer={
        <ModalFooterLayout>
          <div style={{ marginRight: "8px" }}>
            <Button
              disabled={getLoading()}
              ghost
              size="large"
              type="default"
              onClick={onCancel || closeModal}
            >
              {cancelText || "취소"}
            </Button>
          </div>
          <Button
            disabled={getLoading()}
            danger={isDanger}
            type="primary"
            size="large"
            onClick={onOk || closeModal}
          >
            {okText || "확인"}
          </Button>
        </ModalFooterLayout>
      }
    >
      {contents}
    </StyledModal>
  );
};
export default ConfirmModal;

const StyledModal = styled(Modal)`
  border-radius: 8px;
  z-index: 100000;
  div.ant-modal-content {
    border-radius: 8px;
  }
  div.ant-modal-body {
    padding: 8px 24px 0px 24px;
  }
  div.ant-modal-header {
    border: none;

    padding: 24px 24px 0px 24px;
    border-radius: 8px;
  }
  button {
    span.ant-modal-close-x {
      display: none;
    }
  }
  div.ant-modal-footer {
    border-top: none;
    padding: 24px;
  }
`;
